module.exports = __webpack_public_path__ + "f87781ef43441115418cd9a82959b85e.svg";